   IdDonneePere: {{tpl.IdDonneePere}}<br />
   IdDonneeFils: {{tpl.IdDonneeFils}}<br />
   IdRelation:{{tpl.IdRelation}}<br />
   IdentBO: {{tpl.IdentBO}}
